import { render, staticRenderFns } from "./Ipo.vue?vue&type=template&id=21147720"
import script from "./Ipo.vue?vue&type=script&lang=js"
export * from "./Ipo.vue?vue&type=script&lang=js"
import style0 from "./Ipo.vue?vue&type=style&index=0&id=21147720&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports